<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div v-if="permission.access">
    <div class="row">
      <div class="col-md-8">
        <b-card title="Options List">
          <b-row class="mb-2">
            <!-- Per Page -->
            <b-col
              cols="12"
              md="4"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Show</label>
              <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->
              <v-select
                @on-change="paginateChange"
                :options="perPageOptions"
                v-model="search.paginate"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entries</label>
            </b-col>
            <b-col cols="12" md="4">
              <v-select
                id="option_category_id"
                v-model="search.option_category_id"
                placeholder="Select Category"
                :options="categories"
                label="name_en"
                :reduce="(option) => option.id"
              >
                <template #option="{ name_en, name_bn }">
                  <span> {{ name_en }} ({{ name_bn }})</span>
                </template>
              </v-select>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="4">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="search.search_data"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
                />
              </div>
            </b-col>
          </b-row>
          <b-card-text>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-center">Sl</th>
                    <th class="text-center">Icon</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th class="text-center">Status</th>
                    <th class="text-center" v-if="permission.edit">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(option, index) in options.data"
                    :key="index"
                    v-if="options.data.length"
                  >
                    <td class="align-middle text-center">
                      {{ options.from + index }}
                    </td>
                    <td class="align-middle text-center">
                      <img
                        height="40"
                        :src="$store.state.base_url + option.file_link"
                        alt=""
                      />
                    </td>
                    <td><b></b>{{ option.name }}</td>
                    <td>
                      <span v-if="option.category">{{
                        option.category.name_en
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span
                        class="badge"
                        :class="
                          option.status == 1 ? 'badge-success' : 'badge-danger'
                        "
                      >
                        {{ option.status == 1 ? "Active" : "Inactive" }}
                      </span>
                    </td>
                    <td class="align-middle text-center" v-if="permission.edit">
                      <button
                        class="btn btn-primary btn-sm"
                        @click="edit(option.id)"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <pagination
                :data="options"
                @pagination-change-page="getResults"
                align="center"
                :show-disabled="true"
                :limit="5"
              ></pagination>
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-md-4" v-if="permission.create || form.id != ''">
        <b-card :title="(form.id == '' ? 'Create' : 'Update') + ' Department'">
          <b-card-text
            ><validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
                enctype="multipart/form-data"
              >
                <div class="row">
                  <div class="col-md-12">
                    <!-- email -->
                    <b-form-group
                      label="Category Id"
                      label-for="option_category_id"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="option_category_id"
                        rules="required"
                      >
                        <v-select
                          id="option_category_id"
                          v-model="form.option_category_id"
                          placeholder="Select Category"
                          :options="categories"
                          label="name_en"
                          :reduce="(option) => option.id"
                        >
                          <template #option="{ name_en, name_bn }">
                            <span> {{ name_en }} ({{ name_bn }})</span>
                          </template>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <!-- email -->
                    <b-form-group label="Name" label-for="name">
                      <validation-provider
                        #default="{ errors }"
                        name="name"
                        rules="required"
                      >
                        <b-form-input
                          id="name"
                          v-model="form.name"
                          :state="errors.length > 0 ? false : null"
                          name="name"
                          placeholder="Enter Your Name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <div class="d-block" style="height: 350px">
                      <b-form-group label="Description" label-for="description">
                        <validation-provider
                          #default="{ errors }"
                          name="description"
                        >
                          <!-- :options="snowOption" -->
                          <quill-editor
                            id="description"
                            style="height: 220px"
                            class="mb-4"
                            v-model="form.description"
                            name="description"
                            placeholder="Enter Your Description"
                          />
                          <div style="clear: both"></div>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <!-- email -->
                    <b-form-group label="Video ID" label-for="video_id">
                      <validation-provider
                        #default="{ errors }"
                        name="video_id"
                      >
                        <b-form-input
                          id="video_id"
                          v-model="form.video_id"
                          :state="errors.length > 0 ? false : null"
                          name="video_id"
                          placeholder="Enter Your Video ID"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <!-- email -->
                    <b-form-group label="Button Name" label-for="btn_name">
                      <validation-provider
                        #default="{ errors }"
                        name="btn_name"
                      >
                        <b-form-input
                          id="btn_name"
                          v-model="form.btn_name"
                          :state="errors.length > 0 ? false : null"
                          name="btn_name"
                          placeholder="Enter Your Button Name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <div class="border rounded p-2 mb-2">
                      <b-media
                        no-body
                        vertical-align="center"
                        class="flex-column flex-md-row"
                      >
                        <b-media-aside>
                          <b-img
                            :src="icon_image"
                            height="50"
                            width="50"
                            class="rounded mr-2 mb-1 mb-md-0"
                          />
                        </b-media-aside>
                        <b-media-body>
                          <b-form-file
                            id="icon_image"
                            accept=".jpg, .png, .gif"
                            @change="loadImage($event)"
                            placeholder="Select Icon Image"
                            drop-placeholder="Drop file here..."
                          />
                        </b-media-body>
                      </b-media>
                    </div>
                  </div>
                </div>
                <!-- submit buttons -->
                <b-form-checkbox
                  name="status"
                  style="margin-top: 5px"
                  v-model="form.status"
                  switch
                  inline
                >
                </b-form-checkbox>
                <b-button
                  type="submit"
                  class="float-right"
                  variant="primary"
                  @click="validationForm"
                >
                  {{ form.id == "" ? "Create" : "Update" }}
                </b-button>
                <b-button
                  type="submit"
                  class="float-right mx-1"
                  variant="outline-primary"
                  @click="Close"
                >
                  Close
                </b-button>
              </b-form>
            </validation-observer></b-card-text
          >
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import _ from "lodash";

export default {
  data() {
    return {
      search: {
        search_data: "",
        option_category_id: "",
        paginate: 20,
        page: 1,
      },
      perPageOptions: [20, 35, 50, 100],
      form: {
        id: "",
        option_category_id: null,
        name: "",
        description: "",
        status: true,
        icon_image: "",
        video_id: "",
        btn_name: "",
      },
      icon_image: this.$store.state.base_url + "images/department/default.png",
      options: {},
      permission: {
        access: false,
        create: false,
        edit: false,
        delete: false,
      },
    };
  },
  mounted() {
    this.getResults();
    this.$store.dispatch("getOptionCategory");
    this.Permission();
  },
  methods: {
    async getResults(page) {
      this.search.page = page == null ? this.search.page : page;
      const options = await this.callApi(
        "post",
        "/app/course/option?page=" + this.search.page,
        this.search
      );
      if (options.status == 200) {
        this.options = options.data.options;
      }
    },

    paginateChange() {
      this.search.page = 1;
      this.getResults();
    },

    SearchData: _.debounce(function () {
      this.search.page = 1;
      this.getResults();
    }, 1000),

    loadImage(e) {
      this.form.icon_image = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.icon_image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    Close() {
      this.form.id = "";
      this.form.name = "";
      this.form.option_category_id = null;
      this.form.description = "";
      this.form.status = true;
      this.form.icon_image = "";
      this.form.video_id = "";
      this.form.btn_name = "";
      this.icon_image =
        this.$store.state.base_url + "images/department/default.png";
    },

    async edit(id) {
      const option = await this.callApi(
        "post",
        "/app/course/option/show/" + id
      );
      if (option.status == 200) {
        this.form.id = option.data.option.id;
        this.form.name = option.data.option.name;
        this.form.option_category_id = option.data.option.option_category_id;
        this.form.description = option.data.option.description;
        this.form.status = option.data.option.status == true ? true : false;
        this.form.video_id = option.data.option.video_id;
        this.icon_image =
          this.$store.state.base_url + option.data.option.file_link;
      }
    },

    add() {
      const fd = new FormData();
      if (this.form.icon_image) {
        fd.append(
          "icon_image",
          this.form.icon_image,
          this.form.icon_image.name
        );
      }
      fd.append("id", this.form.id);
      fd.append("name", this.form.name);
      fd.append("option_category_id", this.form.option_category_id);
      fd.append("description", this.form.description);
      fd.append("status", this.form.status);
      fd.append("video_id", this.form.video_id);
      fd.append("btn_name", this.form.btn_name);
      axios
        .post("/app/course/option/add", fd)
        .then((res) => {
          this.getResults();
          this.Close();
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.icon_image)
              this.e(e.response.data.errors.icon_image[0]);
            if (e.response.data.errors.name)
              this.e(e.response.data.errors.name[0]);
            if (e.response.data.errors.option_category_id)
              this.e(e.response.data.errors.option_category_id[0]);
            if (e.response.data.errors.description)
              this.e(e.response.data.errors.description[0]);
            if (e.response.data.errors.status)
              this.e(e.response.data.errors.status[0]);
          }
        });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.add();
        }
      });
    },

    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "course.option.access") {
          this.permission.access = true;
        }

        if (permission.slug == "course.option.create") {
          this.permission.create = true;
        }

        if (permission.slug == "course.option.edit") {
          this.permission.edit = true;
        }

        if (permission.slug == "course.option.destroy") {
          this.permission.delete = true;
        }
      });
    },
  },
  components: {
    quillEditor,
    vSelect,
    BCard,
    BCardText,
    BLink,
    BTabs,
    BTab,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
  },
  computed: {
    categories() {
      return this.$store.getters.getOptionCategory;
    },
  },
  watch: {
    "search.search_data": function (val) {
      this.SearchData();
    },
    "search.option_category_id": function (val) {
      this.SearchData();
    },
    "search.paginate": function (val) {
      this.paginateChange();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
